export function isStaffUser(currentUser) {
  return Boolean(
    currentUser?.identity?.is_staff || currentUser?.features?.debug_mode_available
  );
}

export function isDebugModeEnabled(currentUser) {
  return isStaffUser(currentUser) && Boolean(currentUser?.features?.debug_mode);
}
